import { render, staticRenderFns } from "./reporte_declaraciones.vue?vue&type=template&id=ee36ad0c"
import script from "./reporte_declaraciones.js?vue&type=script&lang=js&external"
export * from "./reporte_declaraciones.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports